/**
 * 后端返回的图片/视频是相对路径（如 uploads/product/xxx.jpg，没有前导 /）。
 *
 * history 模式下页面地址是深层路由（如 /cn/products/10），浏览器会把相对路径
 * 解析成 /cn/products/uploads/product/xxx.jpg，导致 404、图片不显示；
 * hash 模式时地址是 /#/cn/products/10，基路径恒为 /，所以一直没暴露。
 *
 * 这里统一把 uploads/ 开头的路径补齐成以 / 开头的根路径：
 *   uploads/product/xxx.jpg -> /uploads/product/xxx.jpg
 * 已经是绝对路径（/uploads/... 或 http(s)://...）的保持原样。
 */
const UPLOAD_PATH = /^uploads\//i;

function normalizeString(value) {
  return UPLOAD_PATH.test(value) ? `/${value}` : value;
}

export default function normalizeUploadPath(data) {
  if (Array.isArray(data)) {
    return data.map(normalizeUploadPath);
  }
  if (data && typeof data === 'object') {
    const result = {};
    Object.keys(data).forEach((key) => {
      result[key] = normalizeUploadPath(data[key]);
    });
    return result;
  }
  if (typeof data === 'string') {
    return normalizeString(data);
  }
  return data;
}
